import { api } from '../../../../../../../lib';
import { GetLimitDataParsedResponse, parseGetLimitDataResponse, RegisterLimitModelReturn } from '../../lib/data';
import { GetLimitDataRawResponse } from '../../lib/mock';

export const getLimitData = async (limitId: string): Promise<GetLimitDataParsedResponse> => {
  const response = await api.get<GetLimitDataRawResponse>(`/limits/${limitId}`, { expectToken: true });
  return parseGetLimitDataResponse(response.data);
};

export const getLimitDataQuery = (limitId: string) => {
  return {
    queryKey: ['limitData', limitId],
    queryFn: () => getLimitData(limitId),
  };
};

export const updateLimitData = async (limitId: string, data: RegisterLimitModelReturn) => {
  const response = await api.put<GetLimitDataRawResponse>(`/limits/${limitId}`, data, { expectToken: true });
  return response;
};
